import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesSushiLunchService } from "../../../shared/services";
import { IRulesSushiLunch } from "../../../redux/@types/rulesSushiLunch";

export const useRulesSushiLunch = ({ rule_id }: { rule_id: number }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [ruleById, setRuleById] = React.useState<IRulesSushiLunch>();

  const getRuleById = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await rulesSushiLunchService.get(rule_id);
      setRuleById(res);
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    getRuleById();
  }, [rule_id]);

  return {
    loading,
    ruleById,
    getRuleById,
  };
};
